module.exports = __webpack_public_path__ + "img/社·会·责·任.8de10d39.png";